export default "/assets/laying-bed2.c4b1be0f18c2a614f741596db0c1a64b.png";